import { cx } from 'class-variance-authority'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React, { useMemo } from 'react'
import { getRandomPrimaryColor } from '../../constants'

export type HeaderMediaProps = {
  headerMediaImage: string | IGatsbyImageData | null
  tool?: boolean
  colorCareerSite?: string
}

const HeaderMedia: React.FC<HeaderMediaProps> = ({
  headerMediaImage,
  tool = false,
  colorCareerSite = undefined,
}) => {
  const colorToDisplay = useMemo(
    () => (colorCareerSite ? undefined : getRandomPrimaryColor()),
    [colorCareerSite],
  )

  if (
    headerMediaImage &&
    typeof headerMediaImage !== 'string' &&
    'images' in headerMediaImage
  ) {
    return (
      <div>
        <GatsbyImage
          image={headerMediaImage as IGatsbyImageData}
          alt="header"
          className={`lg:h-96 ${
            !tool && 'h-screen'
          } h-96 w-screen brightness-[0.3]`}
        />
      </div>
    )
  }

  if (typeof headerMediaImage === 'string') {
    return (
      <div className="w-screen">
        <img
          src={headerMediaImage}
          alt="header"
          className={`lg:h-96 object-cover object-center ${
            !tool && 'h-screen'
          } h-96 w-screen brightness-[0.3]`}
        />
      </div>
    )
  }

  return (
    <div
      className={cx(
        `lg:h-96 object-contain ${
          !tool && 'h-screen'
        } h-96 w-screen brightness-[0.7]`,
        colorToDisplay && `bg-${colorToDisplay}`,
      )}
      style={{
        backgroundColor: colorCareerSite,
      }}
    />
  )
}

export default HeaderMedia
